import { useContext } from 'react';

import { ReferralAlertsContext } from '@/providers/ReferralAlertsProvider';

/**
 * Hook to access referral alerts functionality
 * - Use `triggerReferralAlerts()` to show the alerts immediately
 * - Use `clearReferralAlerts()` to hide them
 * - Check `showReferralAlerts` to determine if they should be visible
 */
export const useReferralAlerts = () => {
  const context = useContext(ReferralAlertsContext);

  if (context === undefined) {
    throw new Error(
      'useReferralAlerts must be used within a ReferralAlertsProvider'
    );
  }

  return context;
};
